import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Drops into a Router context and scrolls the window to the top on every
 * route change. Render it once inside <BrowserRouter> (or equivalent) — it
 * returns null so it has no visual output.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}
